import type { ComponentType } from "react";
import { ActionItemsSection } from "./ActionItemsSection";
import { BentoGridSection } from "./BentoGridSection";
import { CalloutSection } from "./CalloutSection";
import { ChecklistSection } from "./ChecklistSection";
import { DecisionsSection } from "./DecisionsSection";
import { DeepDivesSection } from "./DeepDivesSection";
import { KeyValueSection } from "./KeyValueSection";
import { KpiCardsSection } from "./KpiCardsSection";
import { MarkdownSection } from "./MarkdownSection";
import { OpenQuestionsSection } from "./OpenQuestionsSection";
import { ProgressTrackerSection } from "./ProgressTrackerSection";
import { QuoteSection } from "./QuoteSection";
import { ReactFlowSection } from "./ReactFlowSection";
import { TableSection } from "./TableSection";
import { TimelineSection } from "./TimelineSection";

export type SectionData = {
  type: string;
  title: string;
  data: any;
};

export type SectionComponentProps = {
  data: any;
};

// Section types currently rendered on FlameKing. Mirrors OS section types,
// pruned to what's actually used by FlameKing/Yogev pages (15 of OS's ~30).
// Add new types as content arrives.
export const SECTION_REGISTRY: Record<string, ComponentType<SectionComponentProps>> = {
  action_items: ActionItemsSection,
  bento_grid: BentoGridSection,
  callout: CalloutSection,
  checklist: ChecklistSection,
  decisions: DecisionsSection,
  deep_dives: DeepDivesSection,
  key_value: KeyValueSection,
  kpi_cards: KpiCardsSection,
  markdown: MarkdownSection,
  open_questions: OpenQuestionsSection,
  progress_tracker: ProgressTrackerSection,
  quote: QuoteSection,
  react_flow: ReactFlowSection,
  table: TableSection,
  timeline: TimelineSection,
};
